import { call, put, takeLatest } from 'redux-saga/effects';
import Organization from '../../api/organization';
import {
  actionTypes,
  getCountriesSuccess,
  getOrganizationsSuccess,
  getOrganizationSuccess,
  updateOrganizationSuccess,
} from '../actions/organization';

function* getCountries() {
  try {
    const result = yield call(() => Organization.getCountries());
    yield put(getCountriesSuccess(result));
  } catch (error) {
    console.log(error);
  }
}

function* getOrganizations(action) {
  try {
    const result = yield call(() => Organization.getOrganizations(action.payload));
    yield put(getOrganizationsSuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* createOrganization(action) {
  try {
    const result = yield call(() => Organization.createOrganization(action.payload));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* getOrganization(action) {
  try {
    const result = yield call(() => Organization.getOrganization(action.payload));
    yield put(getOrganizationSuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

function* updateOrganization(action) {
  try {
    const result = yield call(() => Organization.updateOrganization(action.payload.id, action.payload));
    yield put(updateOrganizationSuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(null, error?.response?.data?.message);
  }
}

export default function* organizationSaga() {
  yield takeLatest(actionTypes.GET_ORGANIZATION_COUNTRIES, getCountries);
  yield takeLatest(actionTypes.GET_ORGANIZATIONS, getOrganizations);
  yield takeLatest(actionTypes.CREATE_ORGANIZATION, createOrganization);
  yield takeLatest(actionTypes.GET_ORGANIZATION, getOrganization);
  yield takeLatest(actionTypes.UPDATE_ORGANIZATION, updateOrganization);
}
